import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UserLayout from '../util/UserLayout'
import {getUserOrders} from "../../redux/actions/orderAction"
import { useState } from 'react'
import Loader from '../../components/util/Loader'
import moment from 'moment'

const MyOrders = () => {

    // const orders = [{},{},{},{}]
    const dispatch = useDispatch()
    const {orders} = useSelector(state=>state.orders)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      setLoading(true)
      dispatch(getUserOrders())
      .then(res=>{
        setLoading(false)
      })
    }, [])
    

  return (
    <UserLayout>
        {loading ? <Loader/> : orders.length !==0 ? orders.reverse().map((item, index)=>(
            <div className="card card-lg mb-5 border" key={index}>
            <div className="card-body pb-0">
              {/* Info */}
              <div className="card card-sm">
                <div className="card-body bg-light">
                  <div className="row">
                    <div className="col-6 col-lg-3">
                      {/* Heading */}
                      <h6 className="heading-xxxs text-muted">Placed On:</h6>
                      {/* Text */}
                      <p className="mb-lg-0 font-size-sm font-weight-bold">
                        {moment(item.createdAt).format('LL')}
                      </p>
                    </div>
                    <div className="col-6 col-lg-3">
                      {/* Heading */}
                      <h6 className="heading-xxxs text-muted">Ship to:</h6>
                      {/* Text */}
                      <p className="mb-lg-0 font-size-sm font-weight-bold">
                        {item.shippingInfo.name}
                      </p>
                    </div>
                    <div className="col-6 col-lg-3">
                      {/* Heading */}
                      <h6 className="heading-xxxs text-muted">Status:</h6>
                      {/* Text */}
                      <p className="mb-0 font-size-sm font-weight-bold">
                        {item.paymentInfo.status === "Paid" ? item.orderStatus : `Payment ${item.paymentInfo.status}`}
                      </p>
                    </div>
                    <div className="col-6 col-lg-3">
                      {/* Heading */}
                      <h6 className="heading-xxxs text-muted">Order Amount:</h6>
                      {/* Text */}
                      <p className="mb-0 font-size-sm font-weight-bold">
                        Rs {item.totalPrice}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="row align-items-center">
                <div className="col-12 col-lg-6">
                  <div className="form-row mb-4 mb-lg-0">
                    {item.orderItems.map((orderItem, index)=>(
                    <>
                      {index < 3 && <div className="col-3" key={index}>
                      <div className="embed-responsive embed-responsive-1by1" style={{backgroundImage: `url(${orderItem.image})`, backgroundSize:"contain", backgroundRepeat:"no-repeat"}} />
                    </div>}
                    </>
                    ))}
                    {item.orderItems.length > 3 && <div className="col-3">
                      {/* Image */}
                      <div className="embed-responsive embed-responsive-1by1 bg-light">
                        <a className="embed-responsive-item embed-responsive-item-text text-reset">
                          <div className="font-size-xxs font-weight-bold">
                            +{item.orderItems.length - 3} <br /> more
                          </div>
                        </a>
                      </div>
                    </div>}
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="form-row">
                    <div className="col-6">
                      {/* Button */}
                      <a className="btn btn-sm btn-block btn-outline-dark" href="#">
                        Order Details
                      </a>
                    </div>
                    <div className="col-6">
                      {/* Button */}
                      {item.paymentInfo.status !== "Paid" ?  <a className="btn btn-sm btn-block btn-dark" href={`/payments/${item._id}`}>
                        Pay Now
                      </a> :  <a className="btn btn-sm btn-block btn-outline-dark" href="#!">
                        Track order
                      </a>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )): <div className='h-100 d-flex align-items-start justify-content-center'>No orders yet</div>}
    </UserLayout>
  )
}

export default MyOrders